import { createSlice } from "@reduxjs/toolkit";
import useApi from "../api";

// Define the state interface
interface ColorsState {
    results: any[];
}

// Initialize the state
const initialState: ColorsState = {
    results: [],
};

// Create the slice with only setColors
const colorsSlice = createSlice({
    name: "colors",
    initialState,
    reducers: {
        setColors(state, action) {
            state.results = action.payload;
        },
    },
});

// Export the setColors action
export const { setColors } = colorsSlice.actions;

// Asynchronous thunk to fetch colors from the API
export const fetchColors = () => async (dispatch: any) => {
    const api = useApi();
    try {
        const response = await api.getColor();
        dispatch(setColors(response));
    } catch (error) {
        console.error("Error retrieving colors:", error);
    }
};


export default colorsSlice.reducer;
